import { animate, animation, style } from '@angular/animations';

export const slideUp = animation([
  style({ height: '*', opacity: 1, 'padding-top': '*', 'padding-bottom': '*' }),
  animate('300ms ease', style({height: 0, opacity: 0, 'padding-top': 0, 'padding-bottom': 0 }))
]);
